// src/components/PageTransition.tsx
import * as React from "react";
import { AnimatePresence, motion } from "framer-motion";

const variants = {
  initial: {
    opacity: 0.95,
    y: 10,
  },
  in: {
    opacity: 1,
    y: 0,
  },
  out: {
    opacity: 0.95,
    y: -10,
  },
};

const transition = {
  duration: 0.25,
  ease: "easeInOut",
};

export default function PageTransition({ element, location }) {
  return (
    <AnimatePresence mode="sync">
      <motion.main
        key={location.pathname}
        variants={variants}
        initial="initial"
        animate="in"
        exit="out"
        transition={transition}
        style={{
          width: "100%",
          backgroundColor: "inherit",
        }}
      >
        {element}
      </motion.main>
    </AnimatePresence>
  );
}
